import React from "react"
import Layout from "./../../components/layout"
import SEO from "./../../components/seo"
import YouTube from 'react-youtube';
import Header from "./../../components/header"

export default function Video1() {
  const videoId = '5ZNS9goLXTQ';
  const title = "Vidéo #1 - Exposition Bistrot";
  return (
    <Layout>
      <SEO title={title} />
      <Header title="Retour" href="/bistrot" />
      <div className="video-page">
        <YouTube videoId={videoId} containerClassName='player-wrapper' />
      </div>
    </Layout>
  )
}
